module.exports = __webpack_public_path__ + "img/ilst_topletter.85ff6670.png";